import QuotationContext from '@contexts/QuotationContext/QuotationContext';
import { useContext } from 'react';

function useQuotation() {
  return useContext(QuotationContext);
}

export default useQuotation;
